module.exports = "/fonts/halona-picturemark-l-c0564885813040c54c021e5172b73ad6.svg";